import React, { lazy, Suspense } from 'react';
import PrivateRoute from './guard';
import { Navigate, useRoutes } from 'react-router-dom';
const Chat = lazy(async () => await import('src/pages/Chat/index'));

const routes = [
  {
    name: 'null',
    path: '*',
    element: <Suspense><PrivateRoute><Navigate replace to="" /></PrivateRoute></Suspense>
  }, {
    name: 'chat',
    path: '',
    element: <Suspense><PrivateRoute><Chat /></PrivateRoute></Suspense>,
    title: '聊天'
  }];

function RootRoute () {
  return useRoutes(routes);
}
export default RootRoute;
